import React from 'react';
import {
    CartActionItems,
    Text,
    AddProductTitleSection,
    AddProductTitle,
    ProductSearchSection,
    SearchWrapper,
    ProductMethodItem,
    MainContainer,
    CartContainer,
    MobileOuterContainer,
    GridItemContainer,
    SearchGridItemContainer,
    ProductMethodsContainer,
    FlexContainer,
    FlexContainerCart,
    CartActionItemsContainerSpaceBetween,
    TopCartActionsContainer,
    ClearTemplateContainer
} from './ProductsAddMethods.styled'; 

import TrashCanRed from 'src/assets/images/trash-can-red.svg';
import TrashCanGrey from 'src/assets/images/trash-can-grey.svg';
import BOMChanges from 'src/assets/images/BOMChanges.svg';
import ExpandAll from 'src/assets/images/ExpandAll.svg';
import CollapseAll from 'src/assets/images/CollapseAll.svg';
import StorageRequest from 'src/assets/images/storage-request.svg';

import ProductSearch from 'src/common/refactoredComponents/addProductMethods/productSearch/ProductSearch';

import Button from 'src/common/refactoredComponents/button/Button';
import { AddIcon } from './ProductsAddMethods.styled';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { expandCollapse } from '../../../utils/util';
import { Hidden, useMediaQuery } from '@material-ui/core';
import * as MCFontConstants from 'src/styles/fonts/MCFontConstants';
import { useTheme } from '@material-ui/core/styles';



const ProductsAddMethods = ({
    cartCount,
    disabledEmptyCart,
    products,
    popupToShow,
    productValidation,
    setProductsToBeAddedToCart,
    productsToBeAddedToCart,
    clearError,
    setSelectedAddProductMethod,
    handleProductClick,
    isFromSurgeryTemplate = false,
    addProductToTemplate,
    AccountOrSurgeonError,
    isFromEquity = false,
    isFromEquityTemplate,
    isFromConsignmentADD = false,
    isTemplate = false,
    isFromSurgery = false,
    expandedProducts,

    expandAll = () => {},
    collapseAll = () => {},
    productBomDetails,
    pricing,
    setProductToBeAdded = () => {},
    setAdded = () => {},
    setAddProductMethodFromSearch = () => {},
    lastClickedAction = () => {},
    addProductVisibility = [],
    setIsFromCondensedViewProductSearch=()=>{},
    setFromSearch=()=>{},
    cartData = [],
}) => {
    const { t } = useTranslation();

    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    const theme = useTheme();
    const isBelowMd = useMediaQuery(theme.breakpoints.down('960'));
    // below varialble will be removed once the configuration is done from backend to manage the visibility of add product methods
    const tempAddProductVisibility =
        !isFromSurgery && !isFromEquity && !isTemplate;

    const showProductGuide =
        tempAddProductVisibility ||
        addProductVisibility?.includes('Product Guide');
    const showProductTemplates =
        (tempAddProductVisibility ||
            addProductVisibility?.includes('Product Templates')) &&
        !isFromConsignmentADD;
    const showQuickOrder =
        tempAddProductVisibility ||
        addProductVisibility?.includes('Quick Order');

    // Count visible buttons
    const visibleButtonsCount = [showProductGuide, showProductTemplates, showQuickOrder].filter(Boolean).length;

    return (
        <>
            <>
                <MobileOuterContainer isFromEquityTemplate={isFromEquityTemplate} isTemplate={isTemplate}>
                    {!isTemplate && (
                <CartContainer isFromEquityTemplate={isFromEquityTemplate} isTemplate={isTemplate}>
                    
                    <FlexContainerCart>
                      
                        {!isTemplate && (
                            <GridItemContainer isLanguageChanged={isLanguageChanged} >
                                <AddProductTitleSection>
                                    {cartCount > 0 ? (
                                        <AddProductTitle
                                            fontSize={'20px'}
                                            fontFamily={'AvenirNextWorld Demi'}
                                            width={isLanguageChanged ? '100%' : '100%'}
                                        >
                                            {`${t(
                                                'scheduleSurgery.cart.cartText'
                                            )} (${cartCount})`}
                                        </AddProductTitle>
                                    ) : (
                                        <AddProductTitle
                                            width={isLanguageChanged ? '100%' : '100%'}
                                        >
                                            {`${t(
                                                'scheduleSurgery.cart.cartText'
                                            )}`}{' '}
                                            {''} (0)
                                        </AddProductTitle>
                                    )}
                                </AddProductTitleSection>
                            </GridItemContainer>
                        )}



                        
                        {/* Product Methods Container - 50% of total area */}
                        {!isTemplate && (
                        <TopCartActionsContainer
                        >
                            {/* BOM Changes */}
                            <Hidden xsDown>
                                {!isFromEquity &&
                                    !isTemplate &&
                                    !isFromConsignmentADD &&
                                    cartCount > 0 &&
                                    productBomDetails?.some(
                                        (item) => item.billOfMaterialsHistory
                                    ) && (
                                        <div>
                                            <CartActionItems>
                                                <AddIcon displayVariant={'flex'} paddingVariant={'iconSpacing'}>
                                                    <img
                                                        width="14px"
                                                        height="14px"
                                                        src={BOMChanges}
                                                    />
                                                </AddIcon>
                                                <Text fontSizeVariant={'small'} variant={'bomChange'}>
                                                    {t('common.bomChange')}
                                                </Text>
                                            </CartActionItems>
                                        </div>
                                     )}
                            </Hidden>

                            {/* Reservation Required */}
                            <Hidden xsDown>
                                {!isFromEquity &&
                                    !isTemplate &&
                                    !isFromConsignmentADD &&
                                    cartCount > 0 &&
                                    products?.some(
                                        (product) => product?.isReservationSet
                                    ) && (
                                        <div>
                                            <CartActionItems>
                                                <AddIcon displayVariant={'flex'} paddingVariant={'iconSpacing'}>
                                                    <img
                                                        width="14px"
                                                        height="14px"
                                                        src={StorageRequest}
                                                    />
                                                </AddIcon>
                                                <Text fontSizeVariant={'small'} variant={'reservationRequired'}>
                                                    {t('common.reservationRequired')}
                                                </Text>
                                            </CartActionItems>
                                        </div>
                                     )} 
                            </Hidden>

                            {/* Empty Cart Button */}
                            {!isTemplate && (
                                <div>
                                  
                                    <Button
                                        id={'common-addProductMethod-emptycart'}
                                        show={true}
                                        height={'35px'}
                                        width={'100%'}
                                        mbPadding={'0'}
                                        backgroundColor={
                                            products.length > 0
                                                ? '#FFFFFF'
                                                : 'transparent'
                                        }
                                        mbJustifyContent={'flex-end'}
                                        border={
                                            !(products.length > 0) && 'none'
                                        }
                                        disabled={
                                            isFromEquity
                                                ? disabledEmptyCart
                                                : (disabledEmptyCart &&
                                                  disabledEmptyCart?.length > 0
                                                      ? !disabledEmptyCart?.filter(
                                                            (item) =>
                                                                products?.some(
                                                                    (data) =>
                                                                        data.cfn !=
                                                                        item.cfn
                                                                )
                                                        ).length > 0
                                                      : false) ||
                                                  products?.every(
                                                      (product) =>
                                                          product.isDeleteButtonPresent ===
                                                          false
                                                  )
                                        }
                                        clicked={() =>
                                            isFromEquity || isFromConsignmentADD
                                                ? popupToShow(true)
                                                : popupToShow()
                                        }
                                    >
                                        <AddIcon displayVariant={'flex'} paddingVariant={'iconSpacing'}>
                                            <img
                                                width="14px"
                                                src={
                                                    products?.length > 0
                                                        ? TrashCanRed
                                                        : TrashCanGrey
                                                }
                                            />
                                        </AddIcon>
                                        <Text
                                            heightVariant={'small'}
                                            variant={
                                                products?.length > 0
                                                    ? 'error'
                                                    : 'disabled'
                                            }
                                            fontSize={'12px'}
                                            whiteSpace={'nowrap'}
                                        >
                                            {t(
                                                'scheduleSurgery.cart.emptyCart'
                                            )}
                                        </Text>
                                    </Button>
                                </div>
                            )}
                        </TopCartActionsContainer>
                        )}
                    </FlexContainerCart>
                   
                </CartContainer>
                 )}

                {isTemplate && typeof popupToShow === 'function' && (
                    <ClearTemplateContainer>
                        <Button
                            id={'template-addProductMethod-emptycart'}
                            show={true}
                            height={'auto'}
                            padding={'6px 10px'}
                            mbPadding={'6px 10px'}
                            borderRadius={'1600px'}
                            border={'1px solid #E40A1A'}
                            mbBorder={'none'}
                            backgroundColor={'#FFF'}
                            mbJustifyContent={'flex-end'}
                            disabled={disabledEmptyCart}
                            clicked={() => popupToShow()}
                        >
                            <AddIcon
                                displayVariant={'flex'}
                                paddingVariant={'iconSpacing'}
                            >
                                <img
                                    width="14px"
                                    src={
                                        disabledEmptyCart
                                            ? TrashCanGrey
                                            : TrashCanRed
                                    }
                                />
                            </AddIcon>
                            <Text
                                heightVariant={'small'}
                                variant={
                                    disabledEmptyCart ? 'disabled' : 'error'
                                }
                                fontSize={'12px'}
                                whiteSpace={'nowrap'}
                            >
                                {t('templates.clearTemplate')}
                            </Text>
                        </Button>
                    </ClearTemplateContainer>
                )}

                <MainContainer isFromEquityTemplate={isFromEquityTemplate} isTemplate={isTemplate}>
                    <FlexContainer  isFromEquityTemplate={isFromEquityTemplate} isTemplate={isTemplate} >
                        <Hidden xsDown>
                            {/* Add Product Title - 20% width */}
                            <GridItemContainer
                                isLanguageChanged={isLanguageChanged}
                                isTemplate={isTemplate}
                            >
                                <AddProductTitleSection>
                                    <AddProductTitle>
                                        {t('scheduleSurgery.cart.addProduct')}
                                    </AddProductTitle>
                                </AddProductTitleSection>
                            </GridItemContainer>
                        </Hidden>

                        {/* Product Search - 40% width */}
                        {(tempAddProductVisibility || addProductVisibility?.includes('Product Search')) && (
                        <SearchGridItemContainer
                        >
                            <ProductSearchSection>
                                <SearchWrapper>
                                    <div className="product-search-component">
                                        <ProductSearch
                                            cartProducts={products}
                                            setAddProductMethodFromSearch={
                                                setAddProductMethodFromSearch
                                            }
                                            setFromSearch={setFromSearch}
                                            setIsFromCondensedViewProductSearch={
                                                setIsFromCondensedViewProductSearch}
                                            setProductToBeAddedEquityTemplate={
                                                setProductToBeAdded
                                            }
                                            setAdded={setAdded}
                                            productValidation={
                                                productValidation
                                            }
                                            isFromEquity={isFromEquity}
                                            isFromEquityTemplate={
                                                isFromEquityTemplate
                                            }
                                            isFromConsignmentADD={
                                                isFromConsignmentADD
                                            }
                                            setProductsToBeAddedToCart={
                                                setProductsToBeAddedToCart
                                            }
                                            productsToBeAddedToCart={
                                                productsToBeAddedToCart
                                            }
                                            clearError={clearError}
                                            AccountOrSurgeonError={
                                                AccountOrSurgeonError
                                            }
                                            setSelectedAddProductMethod={
                                                setSelectedAddProductMethod
                                            }
                                            productSearch={true}
                                            isFromSurgeryTemplate={
                                                isFromSurgeryTemplate
                                            }
                                            addProductToTemplate={
                                                addProductToTemplate
                                            }
                                            innerHeight={innerHeight}
                                            isProductAddMethod={true}
                                            pricing={pricing}
                                            isTemplate={isTemplate}
                                            isSurgery={isFromSurgery}
                                            searchBoxWidth="100%"
                                            products={products}
                                            cartData={cartData}

                                        />
                                    </div>
                                </SearchWrapper>
                            </ProductSearchSection>
                        </SearchGridItemContainer>
                        )}

                        {/* Product Methods Container */}
                        <ProductMethodsContainer visibleCount={visibleButtonsCount}>
                            {/* Product Guide - Extreme Left */}
                            {showProductGuide && (
                                <ProductMethodItem
                                    onClick={(e) => {
                                        const touchHandled =
                                            e.currentTarget.getAttribute(
                                                'data-touch-handled'
                                            );
                                        if (touchHandled === 'true') {
                                            e.currentTarget.removeAttribute(
                                                'data-touch-handled'
                                            );
                                            return;
                                        }
                                        handleProductClick(
                                            t('common.productGuideTitle'),
                                            t('common.productGuideTitle')
                                        );
                                    }}
                                    onTouchStart={(e) => {
                                        e.preventDefault();
                                        e.currentTarget.setAttribute(
                                            'data-touch-handled',
                                            'true'
                                        );
                                        handleProductClick(
                                            t('common.productGuideTitle'),
                                            t('common.productGuideTitle')
                                        );
                                    }}
                                >
                                    +&nbsp;
                                    {isBelowMd
                                        ? t('common.productGuideTitle')
                                        : t('scheduleSurgery.cart.addFromProductGuide')}
                                </ProductMethodItem>
                            )}

                            {/* Product Templates - Center */}
                            {showProductTemplates && (
                                <ProductMethodItem
                                    onClick={() => {
                                        handleProductClick(
                                            t('common.productTemplatesTitle'),
                                            t('common.productTemplatesTitle')
                                        );
                                    }}
                                >
                                    +&nbsp;
                                    {isBelowMd
                                        ? t('scheduleSurgery.details.templateLabel')
                                        : t('scheduleSurgery.cart.addFromTemplate')}
                                </ProductMethodItem>
                            )}

                            {/* Bulk Add - Extreme Right */}
                            {showQuickOrder && (
                                <ProductMethodItem
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleProductClick(
                                            t('common.quickOrderTitle'),
                                            t('common.quickOrderTitle')
                                        );
                                    }}
                                >
                                    +&nbsp;
                                    {isBelowMd
                                        ? t('equity.quickOrder.header.bulkAdd')
                                        : t('scheduleSurgery.cart.addInBulk')}
                                </ProductMethodItem>
                            )}
                        </ProductMethodsContainer>

                        {!isFromEquity &&
                            !isFromConsignmentADD &&
                            !isTemplate &&
                            cartCount > 0 && (
                        <Hidden smUp>
                            <CartActionItemsContainerSpaceBetween>
                                {/* Expand/Collapse All */}
                                <CartActionItems>
                                        <AddIcon
                                            displayVariant={'flex'}
                                            paddingVariant={'iconSpacing'}
                                            cursor={'pointer'}
                                            id="expand-collapse-icon"
                                            onClick={
                                                expandCollapse(
                                                    expandedProducts,
                                                    products,
                                                    lastClickedAction
                                                ) === 'expand'
                                                    ? () => {
                                                          expandAll();
                                                      }
                                                    : () => {
                                                          collapseAll();
                                                      }
                                            }
                                        >
                                            <img
                                                width="14px"
                                                height="14px"
                                                src={
                                                    expandCollapse(
                                                        expandedProducts,
                                                        products,
                                                        lastClickedAction
                                                    ) === 'expand'
                                                        ? ExpandAll
                                                        : CollapseAll
                                                }
                                            />
                                        </AddIcon>
                                        <Text
                                            widthVariant={'medium'}
                                            variant={'secondary'}
                                            fontSizeVariant={'medium'}
                                            fontFamily={MCFontConstants.FONT_FAMILY_DEMI}
                                            id="expand-collapse-text"
                                            onClick={
                                                expandCollapse(
                                                    expandedProducts,
                                                    products,
                                                    lastClickedAction
                                                ) === 'expand'
                                                    ? () => {
                                                          expandAll();
                                                      }
                                                    : () => {
                                                          collapseAll();
                                                      }
                                            }
                                        >
                                            {expandCollapse(
                                                expandedProducts,
                                                products,
                                                lastClickedAction
                                            ) === 'expand'
                                                ? t('equity.cart.expandAll')
                                                : t('equity.cart.collapseAll')}
                                        </Text>
                                    </CartActionItems>

                                {/* BOM Changes */}
                                {!isFromEquity &&
                                    !isTemplate &&
                                    !isFromConsignmentADD &&
                                    cartCount > 0 &&
                                    productBomDetails?.some(
                                        (item) => item.billOfMaterialsHistory
                                    ) && (
                                        <CartActionItems widthVariant={'auto'}>
                                            <AddIcon displayVariant={'flex'} paddingVariant={'iconSpacing'}>
                                                <img
                                                    width="14px"
                                                    height="14px"
                                                    src={BOMChanges}
                                                />
                                            </AddIcon>
                                            <Text variant={'bomChange'}>
                                                {t('common.bomChange')}
                                            </Text>
                                        </CartActionItems>
                                     )} 

                                {/* Reservation Required */}
                                 {!isFromEquity &&
                                    !isTemplate &&
                                    !isFromConsignmentADD &&
                                    cartCount > 0 &&
                                    products?.some(
                                        (product) => product?.isReservationSet
                                    ) && ( 
                                        <CartActionItems>
                                            <AddIcon display={'flex'} padding={'0px 5px 0px 0px'}>
                                                <img
                                                    width="14px"
                                                    height="14px"
                                                    src={StorageRequest}
                                                />
                                            </AddIcon>
                                            <Text variant={'reservationRequired'}>
                                                {t('common.reservationRequired')}
                                            </Text>
                                        </CartActionItems>
                                     )} 

                            </CartActionItemsContainerSpaceBetween>
                        </Hidden>
                        )}
                    </FlexContainer>
                </MainContainer>
                </MobileOuterContainer>
            </>
        </>
    );
};
export default ProductsAddMethods;
